import React from 'react';
import { AgTechDataAction } from "@agtech/core/data/actions/AgTechDataActions";
import { AgTechApiEntityResponse, convertFromEntityResponse } from "@agtech/core/data/actions/AgTechHttpRequests";
import { useAgTechHttpPostEntityRequest, useAgTechHttpPostRequest } from "@agtech/core/data/http/AgTechApiPostRequests";
import { AgTechContact } from "./ContactData";
import { ContactDataGetAllContactsQuery, ContactDataGetContactDetailsQuery } from "./ContactDataQueries";

/// Contact Data Actions

export const useContactDataWriteContactAction = (): AgTechDataAction<AgTechContact, AgTechContact> => {
    const writeContactSubmissionRequest = useAgTechHttpPostEntityRequest<AgTechContact>();

    return {
        name: 'WriteContact',
        getConfiguration: props => ({
            actionExecutionMessage: props.originalEntity?.id ? 'Updating contact...' : 'Creating contact...',
            actionConfirmationMessage: `Successfully ${props.originalEntity?.id ? 'updated' : 'created'} contact`
        }),
        action: async props => {
            return await writeContactSubmissionRequest.post({
                path: 'Contact/Submit',
                postedData: props.submittedEntity
            });
        },
        onSuccess: async props => {
            props.updateQueryData({
                query: ContactDataGetAllContactsQuery,
                update: (contacts) => {
                    return {
                        ...contacts,
                        [props.responseData.id]: props.responseData
                    }
                }
            });

            props.invalidateQuery({
                query: ContactDataGetContactDetailsQuery,
                queryContext: { contactId: props.responseData.id }
            });
        }
    }
}

export const useContactDataImportContactsAction = (): AgTechDataAction<{ operationId: number, contacts: AgTechContact[] }, AgTechContact[]> => {
    const contactImportPostRequest = useAgTechHttpPostRequest<AgTechContact[], AgTechApiEntityResponse<AgTechContact[]>>();

    return {
        name: 'ImportContacts',
        action: async props => {
            return await contactImportPostRequest.post({
                path: 'Contact/Import',
                postedData: props.submittedEntity.contacts.map(cnt => ({
                    ...cnt,
                    operationId: props.submittedEntity.operationId
                })),
            })
            .then(res => convertFromEntityResponse(res));
        },
        onSuccess: async props => {
            props.invalidateQuery({
                query: ContactDataGetAllContactsQuery
            });
        }
    }
}

export const useContactDataDeleteContactAction = (): AgTechDataAction<AgTechContact, boolean> => {
    let contactDeletionHttpRequest = useAgTechHttpPostRequest<AgTechContact, boolean>();

    return {
        name: 'DeleteContact',
        getConfiguration: props => ({
            actionExecutionMessage: 'Deleting contact...',
            actionConfirmationMessage: `Successfully deleted contact`
        }),
        confirm: async props => {
            let contactFullName = `${props.submittedEntity.firstName} ${props.submittedEntity.lastName}`;
            
            return await props.appContext.confirmations.askForConfirmation({
                content: {
                    header: `Are you sure you want to remove "${contactFullName}" from your contacts?`,
                    confirmationButtonText: 'Delete Contact',
                    width: '480px'
                }
            });
        },
        action: async props => {
            return { success: { data: true } };
            
            // return await contactDeletionHttpRequest.post({
            //     path: 'Contact/Delete',
            //     postedData: props.submittedEntity,
            // });
        },
        onSuccess: async props => {
            props.updateQueryData({
                query: ContactDataGetAllContactsQuery,
                update: (contacts) => {
                    delete contacts[props.submittedEntity.id];
                    return contacts;
                }
            });

            props.appContext.popups.closeAll();
        }
    }
}